// extracted by mini-css-extract-plugin
module.exports = {"patient-card":"style_patient-card__3Y5Ja","avatar":"style_avatar__1O4dy","media-heading":"style_media-heading__3XAN1"};